var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnerVercel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 142",
    style: {
      enableBackground: "new 0 0 200 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "100,2.8 147.3,84.7 52.7,84.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.9,122.7c0-9.5-7-15.8-16.7-15.8c-9.7,0-16.7,6.3-16.7,15.8c0,9.5,7.9,15.8,17.6,15.8 c5.9,0,11-2.3,14.2-6.2l-6.7-3.9c-1.8,1.9-4.5,3.1-7.5,3.1c-4.2,0-7.8-2.2-9.1-5.7h24.6C83.8,124.8,83.9,123.8,83.9,122.7z  M58.9,119.7c1.1-3.5,4.1-5.7,8.3-5.7c4.2,0,7.2,2.2,8.3,5.7H58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.6,122.7c0-9.5-7-15.8-16.7-15.8c-9.7,0-16.7,6.3-16.7,15.8c0,9.5,7.9,15.8,17.6,15.8 c5.9,0,11-2.3,14.2-6.2l-6.7-3.9c-1.8,1.9-4.5,3.1-7.5,3.1c-4.2,0-7.8-2.2-9.1-5.7h24.6C178.5,124.8,178.6,123.8,178.6,122.7z  M153.6,119.7c1.1-3.5,4.1-5.7,8.3-5.7c4.2,0,7.2,2.2,8.3,5.7H153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.3,122.7c0,5.3,3.4,8.8,8.8,8.8c3.6,0,6.3-1.6,7.7-4.3l6.8,3.9c-2.8,4.7-8,7.5-14.5,7.5 c-9.7,0-16.7-6.3-16.7-15.8c0-9.5,7-15.8,16.7-15.8c6.5,0,11.7,2.8,14.5,7.5l-6.8,3.9c-1.4-2.7-4.1-4.3-7.7-4.3 C122.7,113.9,119.3,117.5,119.3,122.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.9,
    y: 97.2,
    className: "st0",
    width: 7.9,
    height: 40.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.9,97.2 32.5,139.5 8.2,97.2 17.3,97.2 32.5,123.6 47.8,97.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.7,107.8v8.5c-0.9-0.3-1.8-0.4-2.8-0.4c-5.1,0-8.8,3.5-8.8,8.8v13h-7.9v-29.9h7.9v8.1 C97.1,111.4,102.3,107.8,108.7,107.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerVercel);
export default __webpack_public_path__ + "static/media/partner-vercel.1f1de101afbda2e6df2a3853c2a1bc50.svg";
export { ForwardRef as ReactComponent };